import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 mt-16">
      <div className="bg-white shadow-lg rounded-lg w-5/6 max-w-6xl p-10">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-6">Privacy Policy</h1>
        <p className="text-gray-600 text-center mb-8">
          <strong>Effective Date:</strong> 08-02-2025 | <strong>Last Updated:</strong> 08-02-2025
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">1. Information We Collect</h2>
          <ul className="list-disc list-inside text-gray-600">
            <li><strong>Name</strong></li>
            <li><strong>Email</strong></li>
            <li><strong>Phone Number</strong></li>
            <li><strong>Transaction Details</strong></li>
            <li><strong>Salary Details</strong></li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">2. Data Accuracy</h2>
          <p className="text-gray-600">
            - If data is <strong>invalid</strong>, users will be notified via an <strong>alert</strong> and cannot proceed with submission.  
            - Incorrect data entered by the user is <strong>not our responsibility</strong>, and no modifications will be made post-submission.
          </p>
        </section>

        <div className="text-center mt-6">
          <a href="/" className="text-blue-500 hover:underline text-lg">← Go Back</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
